import React from 'react';
import { PlaneIcon, MapPinIcon, PackageIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1a1a1a] px-5 py-10 text-center text-white md:px-10 md:py-[50px]" data-id="element-62">
      <div className="mb-[25px] flex justify-center" data-id="element-63">
        <img src="https://cdn.magicpatterns.com/uploads/nJcmXJruoXHz7shJJs8Ygp/logo_-_copia.png" alt="RÔA Imported" className="h-[60px] w-auto brightness-0 invert" data-id="element-64" />
      </div>
      <div className="mb-[15px] flex items-center justify-center gap-3 text-[13px] font-bold tracking-[3px]" data-id="element-65">
        <span data-id="element-66">USA</span>
        <PlaneIcon className="h-4 w-4 text-[#888]" data-id="element-67" />
        <span data-id="element-68">ARG</span>
      </div>
      <ul className="mb-[25px] flex flex-wrap justify-center gap-[30px] list-none" data-id="element-69">
        <li data-id="element-70">
          <a href="https://www.instagram.com/roaimported/" target="_blank" rel="noopener noreferrer" className="text-[11px] uppercase tracking-[2px] text-[#888] no-underline transition-colors duration-300 hover:text-white" data-id="element-71">
            Instagram
          </a>
        </li>
        <li data-id="element-72">
          <a href="#" className="text-[11px] uppercase tracking-[2px] text-[#888] no-underline transition-colors duration-300 hover:text-white" data-id="element-73">
            WhatsApp
          </a>
        </li>
        <li data-id="element-74">
          <a href="#" className="text-[11px] uppercase tracking-[2px] text-[#888] no-underline transition-colors duration-300 hover:text-white" data-id="element-75">
            Envíos
          </a>
        </li>
        <li data-id="element-76">
          <a href="#" className="text-[11px] uppercase tracking-[2px] text-[#888] no-underline transition-colors duration-300 hover:text-white" data-id="element-77">
            Contacto
          </a>
        </li>
      </ul>
      <p className="flex items-center justify-center gap-1.5 text-[10px] tracking-[1px] text-[#555]" data-id="element-78">
        <MapPinIcon className="h-3 w-3" data-id="element-79" /> Mar del Plata, Zona Güemes
        <span className="mx-1" data-id="element-80">·</span>
        <PackageIcon className="h-3 w-3" data-id="element-81" /> Envíos a todo el país
      </p>
      <p className="mt-2 text-[10px] tracking-[1px] text-[#555]" data-id="element-82">
        © 2025 RÔA Imported. Todos los derechos reservados.
      </p>
    </footer>;
}